import { useRef } from "react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Family } from "@/components/site/Family";
import { Assessment } from "@/components/site/Assessment";
import { Concerns } from "@/components/site/Concerns";
import { ReportPreview } from "@/components/site/ReportPreview";
import { Process } from "@/components/site/Process";
import { WhenToBook } from "@/components/site/WhenToBook";
import { Pricing } from "@/components/site/Pricing";
import { FAQs } from "@/components/site/FAQs";
import { Closing, Footer } from "@/components/site/Closing";
import { StickyCta } from "@/components/site/StickyCta";

export default function Home() {
  const heroCta = useRef(null);
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-md focus:bg-forest focus:px-4 focus:py-2 focus:text-white">Skip to content</a>
      <Nav />
      <main id="main">
        <Hero ctaRef={heroCta} />
        <Family />
        <Assessment />
        <Concerns />
        <ReportPreview />
        <Process />
        <WhenToBook />
        <Pricing />
        <FAQs />
        <Closing />
      </main>
      <Footer />
      <StickyCta watchRef={heroCta} />
    </div>
  );
}
